import React from "react";
import css from "./Logo.module.css";

function Logo() {
	return (
		<div className={css.tmtLogo}>
			<img className={css.logoImg} src={process.env.PUBLIC_URL + "/img/logo.png"} alt="Turnmytree.com" />
			<br />
			<p className={css.configuratorText}>CONFIGURATOR</p>
		</div>
	);
}

export default Logo;
